const podcast = window.rssPodcastFeed || {};
const { podcastId, wtRegion, enableFilter, defaultFilterName, podcastsNumToShow = '5' } = podcast;

const Config = {
  podcastId,
  wtRegion,
  enableFilter,
  defaultFilterName,
  podcastsNumToShow,
};

export default Config;
